"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VarsValueVariableType = exports.ContractVariableType = void 0;
exports.handleValuePromise = handleValuePromise;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _justPerformance = require("just-performance");
var _VariableReference = require("./VariableReference");
var _ErrorValueTypeHandler = require("../type/ErrorValueTypeHandler");
class VarsValueVariableType {
  constructor() {
    (0, _defineProperty2.default)(this, "valueType", "value");
  }
  getValue(ref, deps, batcher) {
    let ret;
    if (!_VariableReference.variableValPerf[this.type]) {
      _VariableReference.variableValPerf[this.type] = [];
    }
    let start = _justPerformance.performance.now();
    try {
      ret = this.value(deps, batcher);
      _VariableReference.variableValPerf[this.type].push(_justPerformance.performance.now() - start);
    } catch (err) {
      return this.errorToValue(err);
    }
    if (!ret) {
      ref.value = ret;
    } else if (ret.then && typeof ret.then === "function") {
      let prom = ret;
      return handleValuePromise(ref, prom);
    } else {
      ref.value = ret;
    }
  }
  errorToValue(error) {
    let err = error;
    let code = err.code || "unknown_error";
    return {
      code,
      message: err.message,
      data: err.data
    };
  }
}
exports.VarsValueVariableType = VarsValueVariableType;
class ContractVariableType {
  constructor() {
    (0, _defineProperty2.default)(this, "valueType", "contract");
  }
}
exports.ContractVariableType = ContractVariableType;
function handleValuePromise(ref, prom) {
  prom.then(res => {
    ref.value = Object.freeze(res);
  });
  return prom.then(() => null).catch(error => {
    return new _ErrorValueTypeHandler.ValueTypeError(error.code || "unknown_error", error.message, {});
  });
}
//# sourceMappingURL=VariableType.js.map